import { ISnowHistoryItem } from 'api/resort/types';
import {
  SnowItemChart, SnowItemData, SnowItemTh,
} from 'components/resort/RecentSnowfall/SnowItem';

import styles from './styles.module.scss';

interface IRecentSnowfallProps {
  data: Array<ISnowHistoryItem>,
  maxY: number,
  show24Hour?: boolean,
}

export const RecentSnowfall = ({
  data, maxY, show24Hour,
}: IRecentSnowfallProps) => (
  <div className={styles.chartWrapper}>
    <table className={styles.snowChart}>
      <tbody>
        <tr>
          {data.map((d) => <SnowItemChart key={d.date} snow={d.snow} date={d.date} height={d.snow / maxY} show24Hour={show24Hour} />)}
        </tr>
        <tr>
          {data.map((d) => <SnowItemTh key={d.date} snow={d.snow} date={d.date} height={d.snow / maxY} show24Hour={show24Hour} />)}
        </tr>
        <tr>
          {data.map((d) => (
            <SnowItemData
              key={d.date}
              snow={d.snow}
              date={d.date}
              height={d.snow / maxY}
              show24Hour={show24Hour}
            />
          ))}
        </tr>
      </tbody>
    </table>
  </div>
);
